// Carrega a API JavaScript do Google Maps uma única vez. A chave vem da tela Configurações (é pública por
// natureza: a proteção dela é a restrição por referrer e por API no Google Cloud). Rejeita se a chave for
// inválida/recusada (`gm_authFailure`) ou se o script não carregar — quem chama cai no OpenStreetMap.
let promessa = null;

export function carregarGoogleMaps(chave) {
  if (window.google?.maps?.Map) return Promise.resolve(window.google.maps);
  if (promessa) return promessa;
  promessa = new Promise((resolve, reject) => {
    window.gm_authFailure = () => {
      promessa = null;
      reject(new Error('Chave do Google Maps recusada'));
    };
    window.__iniciarGoogleMaps = () => resolve(window.google.maps);
    const s = document.createElement('script');
    s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(chave)}&callback=__iniciarGoogleMaps&loading=async&language=pt-BR&region=BR`;
    s.async = true;
    s.onerror = () => {
      promessa = null;
      reject(new Error('Não foi possível carregar o Google Maps'));
    };
    document.head.appendChild(s);
  });
  return promessa;
}
